<section class="px-container py-16 mb-8" #notizie>
    <h1 class="text-3xl md:text-5xl lg:text-6xl mb-10 md:mb-16">News</h1>

    <div class="gap-x-8 gap-y-16 grid lg:grid-cols-2">
        <ng-container *ngFor="let notizia of news_filtrate;">                        
            <div class="flex flex-col justify-between gap-4 ps-8 relative">
                <div class="top-1/2 left-0 absolute border-gray-300 border-l-2 border-dashed w-2 h-4/5 -translate-y-1/2"></div>
                <div class="info flex flex-col gap-4">
                    <h1 class="text-3xl lg:text-4xl">{{notizia.titolo | titlecase}}</h1>
                    <span class="bg-accent p-2 text-sm self-start">
                        {{notizia.data_creazione | date: 'EEEE dd MMMM yyyy' | titlecase }}
                    </span>
                    <p class="line-clamp-6 w-full font-mono text-justify desc" [class.text-gray-500]="notizia.descrizione.length == 0" [innerHTML]="notizia.descrizione || 'Nessuna ulteriore info disponibile per questa notizia'"></p>
                </div>
                <a *ngIf="!notizia.link" class="lg:mt-4 cta-link self-start" routerLink="/news/{{notizia.url}}">scopri di più</a>
                <a *ngIf="notizia.link" [href]="notizia.link_url" class="lg:mt-4 cta-link self-start">scopri</a>

            </div>
        </ng-container>
    </div>

    <div class="text-center no-result" *ngIf="news.length === 0">
        <h1 class="font-medium text-xl lg:text-2xl">Nessuna notizia recente...</h1>
    </div>

    <div class="mt-20 paginator" *ngIf="news.length >= 8">
        <p-paginator (onPageChange)="onPageChange($event, notizie)" [first]="0" [rows]="8" [totalRecords]="news.length" [showJumpToPageDropdown]="false" />
    </div>

</section>